import axios from 'axios';
export const CHECK_LOGIN = 'user/CHECK_LOGIN';
export const CHECK_LOGIN_DONE = 'vip/CHECK_LOGIN_DONE';
export const LOGIN = 'user/LOGIN';
export const LOGIN_DONE = 'user/LOGIN_DONE';

const initialState = {
    loading: false,
    isLogin: true,
    pathname: ''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
            return { ...state, pathname: action.payload.pathname };
        case CHECK_LOGIN:
            return { ...state, loading: true }
        case CHECK_LOGIN_DONE:
            return {
                ...action.state,
                loading: false
            };
        case LOGIN:
            return { ...state, loading: true, error: null };
        case LOGIN_DONE:
            return { ...state, ...action.state, loading: false };
        default:
            return state;
    }
}

export const checkLogin = () => {
    return dispatch => {
        dispatch({
            type: CHECK_LOGIN
        });
        return axios.get('/api/queryAccount').then(response => {
            const isLogin = response.status === 200 && response.data.code === 1;
            dispatch({
                type: CHECK_LOGIN_DONE,
                state: { isLogin: isLogin }
            });
        }).catch(err => {
            dispatch({
                type: CHECK_LOGIN_DONE,
                state: { isLogin: false }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/reducer/user.js